const isWeb = true;
import { getSystemType } from '@nibfe/mkt-env-api';
import { SystemType } from '@nibfe/mkt-env-api/src/libs/enum';
let libs;
if (true)
    libs = require('@nibfe/mkt-libs');
/**
 * 判断是否在鸿蒙环境
 * 可以使用多种方式判断,根据项目实际情况选择
 */
export function isInHarmony(ctx) {
    var _a, _b;
    try {
        // 方式1: 使用 TechStackUtil (推荐)
        // const { TechStackUtil } = require('@nibfe/mkt-common-utils');
        // return TechStackUtil.isInHarmony();
        // 方式2: 使用 ctx 的 os 参数
        if (((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) === null || _b === void 0 ? void 0 : _b.os) === 'harmony') {
            return true;
        }
        // 方式3: 使用 getSystemType
        const systemType = getSystemType();
        if (systemType === SystemType.harmony) {
            return true;
        }
        return false;
    }
    catch (e) {
        return false;
    }
}
export function getUTM(ctx) {
    try {
        // 优先判断是否为鸿蒙环境
        if (isInHarmony(ctx)) {
            return 'HarmonyOS';
        }
        const systemType = getSystemType();
        let utm_medium = systemType === SystemType.android ? 'android' : 'iphone';
        if (isWeb && libs) {
            const { env } = libs;
            if (env.miniProgram.isMiniProgram()) {
                utm_medium = 'WEIXINPROGRAM';
            }
            else {
                // eslint-disable-next-line no-nested-ternary
                utm_medium = env.system.isAndroid() ? 'android' : env.system.isIphone() ? 'iphone' : '';
            }
        }
        return utm_medium;
    }
    catch (e) {
        return 'iphone';
    }
}
